import { inject, Injectable, Provider } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { EViewType } from 'projects/shared/lib/enum/view-type/view-type.enum';
import { ActivatedRoute } from '@angular/router';
import { IPaginationService, IPaginationServiceToken } from './pagination-service.interface';

@Injectable({
  providedIn: 'root'
})
export class PaginationService implements IPaginationService {
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private queryParamSubscription: Subscription | undefined;
  private paginationSource: BehaviorSubject<number>;
  private paginationObservable: Observable<number>;
  private currentPage: number;

  public constructor() {
    this.currentPage = 1;

    this.queryParamSubscription = this.route.queryParamMap.subscribe(params => {
      let paramValue = params.get('page');
      if (paramValue != null) {
        this.currentPage = parseInt(paramValue);
        this.paginationSet(this.currentPage);
      }
    });

    this.paginationSource = new BehaviorSubject<EViewType>(this.currentPage);
    this.paginationObservable = this.paginationSource.asObservable();
  }

  public paginationGet(): Observable<number> {
    return this.paginationObservable;
  }

  public paginationSet(value: number | undefined): void {
    if (value == undefined) {
      value = 1;
    }

    if (this.paginationSource?.value == value) {
      return;
    }

    this.paginationSource?.next(value);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const PaginationServiceProvider: Provider[] = [
  { provide: IPaginationServiceToken, useExisting: PaginationService }
];
